module.exports = __webpack_public_path__ + "static/media/gallery_07.5fec8b27.png";